import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import router from './router'
import { createApp } from 'vue';
import App from './App.vue';
import VueSmoothScroll from 'vue3-smooth-scroll';


// Create app instance
const app = createApp(App);

// Use plugins
app.use(router);
app.use(VueSmoothScroll);

// Mount the app
app.mount('#app');